<ng-container *ngFor="let freeText of filterFreeTexts(freeTexts)">
  <h3>{{ 'Mobile.CFreeText_' + freeText.FreeTextType | translate }} {{ freeText.LinkedResourceName }}</h3>
</ng-container>
